function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C74F"
    },
    d: "M44.004,409.464c-13.863,0-25.101-11.238-25.101-25.102c0-68.341,16.832-118.159,50.03-148.067 c10.298-9.283,26.173-8.453,35.451,1.847c9.28,10.299,8.453,26.171-1.847,35.451c-21.869,19.704-33.43,58.008-33.43,110.769 C69.107,398.226,57.868,409.464,44.004,409.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M104.382,238.142c-9.277-10.301-25.153-11.131-35.451-1.847 c-8.345,7.518-15.654,16.298-21.924,26.31c0.658,31.385,9.339,60.8,24.09,86.289c4.166-34.62,14.823-60.333,31.437-75.301 C112.836,264.313,113.662,248.441,104.382,238.142z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C74F"
    },
    d: "M429.869,320.133c-15.151,0-31.237-4.656-46.863-13.859c-11.946-7.034-15.928-22.421-8.892-34.366 c7.033-11.946,22.422-15.929,34.366-8.892c13.6,8.01,23.983,7.931,29.164,5.188c3.229-1.71,4.934-4.662,5.218-9.026 c0.896-13.836,12.856-24.321,26.67-23.429c13.836,0.895,24.325,12.835,23.428,26.67c-1.418,21.915-13.017,40.195-31.823,50.153 C451.59,317.626,440.979,320.133,429.869,320.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C74F"
    },
    d: "M293.791,512c-13.864,0-25.102-11.238-25.102-25.102v-95.056c0-13.863,11.238-25.102,25.102-25.102 c13.864,0,25.102,11.238,25.102,25.102v95.056C318.893,500.762,307.655,512,293.791,512z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M293.791,366.74c-13.864,0-25.102,11.238-25.102,25.102v52.646 c17.725-2.831,34.592-8.218,50.204-15.783v-36.863C318.893,377.979,307.655,366.74,293.791,366.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C74F"
    },
    d: "M185.853,512c-13.864,0-25.102-11.238-25.102-25.102v-95.056c0-13.863,11.238-25.102,25.102-25.102 c13.863,0,25.102,11.238,25.102,25.102v95.056C210.955,500.762,199.716,512,185.853,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M185.853,366.74c-13.864,0-25.102,11.238-25.102,25.102v36.863 c15.612,7.565,32.479,12.953,50.204,15.783v-52.646C210.955,377.979,199.716,366.74,185.853,366.74z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0081C6"
    },
    cx: 378.877,
    cy: 85.35,
    r: 57.653
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3C74F"
    },
    cx: 378.877,
    cy: 85.35,
    r: 26.917
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0081C6"
    },
    cx: 100.765,
    cy: 85.35,
    r: 57.653
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F3C74F"
    },
    cx: 100.765,
    cy: 85.35,
    r: 26.917
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M134.851,38.86c-27.107,24.498-50.098,58.223-66.429,94.219 c9.224,6.264,20.357,9.926,32.347,9.926c31.84,0,57.653-25.812,57.653-57.653C158.422,66.266,149.141,49.352,134.851,38.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40BAB3"
    },
    d: "M420.97,243.449C420.97,143.7,337.812,0,239.822,0C141.834,0,58.674,143.7,58.674,243.449 s81.102,180.613,181.148,180.613S420.97,343.199,420.97,243.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M61.726,276.574c15.605,83.927,89.401,147.487,178.096,147.487s162.493-63.56,178.098-147.487 L61.726,276.574L61.726,276.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081C6"
    },
    d: "M93.792,350.318c32.971,44.717,86.095,73.744,146.03,73.744s113.059-29.026,146.03-73.744H93.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M259.031,404.853c-100.046,0-181.148-80.863-181.148-180.613 c0-60.052,30.148-136.022,75.518-186.987c-55.876,49.326-94.727,138.02-94.727,206.196c0,99.75,81.102,180.613,181.148,180.613 c55.006,0,104.279-24.449,137.502-63.037C345.586,388.335,304.244,404.853,259.031,404.853z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D9E6"
    },
    d: "M147.093,326.932c-7.876-13.219-7.876-29.69,0-42.909l0,0c7.876-13.218,7.876-29.69,0-42.909l0,0 c-7.876-13.219-7.876-29.69,0-42.909c7.087-11.895,7.775-26.417,2.107-38.838c-3.548,4.384-8.966,7.192-15.045,7.192 c-6.318,0-11.912-3.042-15.444-7.725c5.934,12.538,5.329,27.306-1.859,39.371l0,0c-7.876,13.219-7.876,29.69,0,42.909l0,0 c7.876,13.219,7.876,29.69,0,42.909l0,0c-7.876,13.219-7.876,29.69,0,42.909l0,0c7.876,13.219,7.876,29.69,0,42.909l0,0 c-0.813,1.364-1.521,2.771-2.166,4.197c8.2,7.813,17.137,14.861,26.693,21.041c-0.784-8.658,1.106-17.503,5.714-25.237 C154.969,356.623,154.969,340.151,147.093,326.932L147.093,326.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D9E6"
    },
    d: "M359.682,326.932c-7.876-13.219-7.876-29.69,0-42.909l0,0c7.876-13.218,7.876-29.69,0-42.909l0,0 c-7.876-13.219-7.876-29.69,0-42.909c7.284-12.226,7.816-27.23,1.626-39.874c-3.503,4.97-9.276,8.226-15.819,8.226 c-5.037,0-9.609-1.94-13.052-5.093c4.679,11.938,3.695,25.509-2.997,36.741c-7.876,13.219-7.876,29.69,0,42.909l0,0 c7.876,13.219,7.876,29.69,0,42.909l0,0c-7.876,13.219-7.876,29.69,0,42.909l0,0c7.876,13.219,7.876,29.69,0,42.909 c-5.993,10.058-7.412,21.996-4.285,32.954c10.46-5.581,20.308-12.151,29.415-19.592c0.913-4.643,2.613-9.167,5.112-13.363 C367.558,356.623,367.558,340.151,359.682,326.932L359.682,326.932z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M252.727,218.899c-4.858,0-9.337-1.653-12.904-4.426c-3.567,2.774-8.047,4.426-12.905,4.426 c-11.615,0-21.062-9.449-21.062-21.062c0-4.507,3.652-8.159,8.159-8.159s8.159,3.652,8.159,8.159c0,2.616,2.129,4.745,4.745,4.745 c2.617,0,4.746-2.129,4.746-4.745c0-4.507,3.652-8.159,8.159-8.159s8.159,3.652,8.159,8.159c0,2.616,2.129,4.745,4.745,4.745 c2.617,0,4.746-2.129,4.746-4.745c0-4.507,3.652-8.159,8.159-8.159s8.159,3.652,8.159,8.159 C273.79,209.451,264.34,218.899,252.727,218.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M345.49,174.717c-15.171,0-27.513-12.342-27.513-27.513c0-4.507,3.652-8.159,8.159-8.159 c4.506,0,8.159,3.652,8.159,8.159c0,6.173,5.022,11.196,11.196,11.196c6.173,0,11.195-5.022,11.195-11.196 c0-4.507,3.652-8.159,8.159-8.159c4.506,0,8.159,3.652,8.159,8.159C373.002,162.374,360.659,174.717,345.49,174.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M134.156,174.717c-15.171,0-27.513-12.342-27.513-27.513c0-4.507,3.652-8.159,8.159-8.159 s8.159,3.652,8.159,8.159c0,6.173,5.022,11.196,11.196,11.196c6.173,0,11.195-5.022,11.195-11.196c0-4.507,3.652-8.159,8.159-8.159 s8.159,3.652,8.159,8.159C161.667,162.374,149.325,174.717,134.156,174.717z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C74F"
    },
    d: "M467.936,285.901c-0.545,0-1.093-0.018-1.645-0.054c-13.836-0.895-24.325-12.835-23.429-26.67 c0.194-2.995-0.185-7.582-5.685-12.825c-9.914-9.452-33.974-18.035-71.767-13.771c-13.795,1.562-26.203-8.354-27.758-22.129 c-1.554-13.776,8.354-26.204,22.129-27.758c47.381-5.348,88.219,4.613,112.035,27.322c14.901,14.206,22.409,32.816,21.142,52.403 C492.101,275.701,481.06,285.901,467.936,285.901z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.c2116de6.svg";
export { ForwardRef as ReactComponent };